module.exports = __webpack_public_path__ + "static/media/conecte.829dfc6b.png";